export const HomeRoutes = {
  index: () => '/'
};

